<template>
    <div class="form-panel-wrapper scroll-tracker">
        <div class="content-list">
            <div class="auto-resp">
                <AutoResponse v-show="isShowFormType" />
            </div>
            <div class="form-box">
                <div class="tit">{{ formLabel }}</div>
                <FormWidgetWrapper
                    v-show="isShowPanel && form.updateState != 'delete'"
                    v-for="form in currentForms"
                    :key="form.uid"
                    :widget="form"
                ></FormWidgetWrapper>
            </div>
        </div>
        <FormMore @widgetSelect="widgetSelect" :isShowDefault="isShowDefault" />
    </div>
</template>

<script>
import FormMore from "./FormMore";
import FormWidgetWrapper from "./FormWidgetWrapper";
import AutoResponse from "./AutoResponse";

export default {
    name: "FormPanel",
    props: ["isShowDefault"],
    components: {
        FormMore,
        FormWidgetWrapper,
        AutoResponse
    },
    data() {
        return {
            isShowPanel: false,
            wtType: "Options",
            isShowFormType: false
        };
    },
    watch: {
        formType(val) {
            val == "2" ? (this.isShowFormType = true) : (this.isShowFormType = false);
        }
    },
    computed: {
        formLabel() {
            return this.$t("zhiji.form.formConfigTitle");
        },
        currentForms() {
            return this.getStorePorp("formInfo").content || [];
        },
        formType() {
            return this.getStorePorp("formInfo").formType || "0";
        }
    },
    methods: {
        widgetSelect() {
            this.isShowPanel = true;
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.formEdit[propName];
        }
    },
    mounted() {
        setTimeout(() => {
            if (this.currentForms.length > 0) {
                this.isShowPanel = true;
            }
        }, 500);
    }
};
</script>

<style lang="less" scoped>
.form-panel-wrapper {
    height: 100%;
    overflow-x: auto;
    background: #fff;

    .auto-resp {
        display: flex;
        flex: 1;
        margin-left: -12px;
        margin-right: 0px;
        background-color: #fafbfd;
        border-bottom: 1px solid #d8e4f0;
    }

    .content-list {
        margin-left: 11px;
        padding: 1px;
        position: relative;

        .tit {
            font-weight: 600;
            margin-top: 18px;
        }
    }

    .form-box {
        background-color: #fff;
    }
}
</style>
